import SuccessPage from "./shared/SuccessPage";

export default function JoinSuccess() {
  return (
    <SuccessPage title="You're in">
      We sent your personal invite link by text. Open it on your phone to get
      started with Finn.
    </SuccessPage>
  );
}
